import { Popup, ToolbarItem } from 'devextreme-react/popup';
import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useAppContext } from './AppContext';

const InactivityHandler = (props) => {
    const {
        warning,
        logout
    } = props;

    // timeout in milliseconds, default is 5 minutes (300,000 ms)
    const app = useAppContext();
    const navigate = useNavigate();

    const warningTimeout = useRef(null);
    const warningVisibleRef = useRef(false);

    const [warningVisible, setWarningVisible] = useState(false);
    const [timeLeft, setTimeLeft] = useState(null);

    let timer;

    const resetWarning = () => {
        if (!warningVisibleRef.current) {
            //console.log("reset warning");
            clearTimeout(warningTimeout.current);
            warningTimeout.current = setTimeout(() => {
                handleWarning();
            }, warning);
        }
    }

    const handleWarning = () => {
        //console.log("handle warning");
        setWarningVisible(true);
        warningVisibleRef.current = true;
        clearInterval(timer);
        startCountdown();
    }

    const handleLogout = () => {
        //console.log("handle logout");
        setWarningVisible(false);
        warningVisibleRef.current = false;
        navigate("/logout");
        // Add additional logout logic here (e.g., clearing tokens, redirecting to login)
    };

    const cancelWarning = () => {
        //console.log("cancel warning");
        clearInterval(timer);
        setWarningVisible(false);
        warningVisibleRef.current = false;
        if (app.loggedIn) {
            resetWarning();
        }
    }

    const cancelWarningOptions = {
        text: 'Cancel',
        stylingMode: 'outlined',
        type: 'normal',
        onClick: cancelWarning,
    };

    useEffect(() => {

        if (app.loggedIn) {

            const handleActivity = () => resetWarning();

            // Add event listeners
            window.addEventListener("mousemove", handleActivity);
            window.addEventListener("keydown", handleActivity);
            window.addEventListener("scroll", handleActivity);

            // Set initial timer
            resetWarning();

            // Cleanup event listeners and timers
            return () => {
                window.removeEventListener("mousemove", handleActivity);
                window.removeEventListener("keydown", handleActivity);
                window.removeEventListener("scroll", handleActivity);

                clearTimeout(warningTimeout.current);
            }
        };
    }, [app.loggedIn]); // Empty dependency array ensures this runs once when component mounts

    useEffect(() => {
        if (timeLeft && (timeLeft.minutes > 0 || timeLeft.seconds > 0)) {
            //console.log(timeLeft);
            timer = setInterval(() => {
                setTimeLeft((prevTime) => {
                    const newTime = prevTime.minutes * 60 * 1000 + prevTime.seconds * 1000 - 1000;
                    return calculateTimeLeft(newTime);
                });
            }, 1000);
        } else if (timeLeft && timeLeft.minutes === 0 && timeLeft.seconds === 0) {
            //console.log("warning time expired");
            clearInterval(timer);
            handleLogout();
        }
        return () => clearInterval(timer);
    }, [timeLeft]);

    const startCountdown = () => {
        //console.log("start countdown");
        setTimeLeft(calculateTimeLeft(logout));
    };

    const calculateTimeLeft = (milliseconds) => {
        if (milliseconds > 0) {
            return {
                minutes: Math.floor(milliseconds / (1000 * 60)),
                seconds: Math.floor((milliseconds / 1000) % 60),
            };
        }
        return { minutes: 0, seconds: 0 };
    };

    return (
        <>
            <Popup
                visible={warningVisible}
                title="Inactivity Warning"
                width={300}
                height={200}
            >
                <div>
                    {timeLeft ? (
                        <div>
                            <span>You will be logged out in </span>
                            <span>
                                {String(timeLeft.minutes).padStart(2, '0')}:
                                {String(timeLeft.seconds).padStart(2, '0')}
                            </span>
                            <span>
                                &nbsp;minutes
                            </span>
                        </div>
                    ) : (
                        <span>00:00</span>
                    )}
                </div>
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={cancelWarningOptions}
                ></ToolbarItem>
            </Popup>
        </>
    );
};

export default InactivityHandler;